import { formatDataStatus, type DataStatus } from '@thottbot/shared';

export function Badge({ status, build }: { status: DataStatus; build?: string | null }) {
  return (
    <span className={`badge ${status}`} title="Data status">
      {formatDataStatus(status, build)}
    </span>
  );
}
